import React from "react";
import MuiBox from "../MuiBox";
import CenterModalHeader from "../CenterModalHeader";
import MuiTypography from "../MuiTypography";
import { useDispatch } from "react-redux";
import { Button } from "@mui/material";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import { closeSecondCenterModal } from "store/slices/SecondCenterModal.slice";
import { useTranslation } from "react-i18next";

const CommonActionModal = ({
  title,
  BodyTitle,
  action,
  onClick,
  backAction,
  secondClose = false,
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  return (
    <>
      <MuiBox
        sx={{
          gap: "1px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CenterModalHeader title={title} secondClose={secondClose} />
        <MuiBox
          sx={{
            width: "100%",
            backgroundColor: "background.white",
            display: "flex",
            p: "20px",
          }}
        >
          <MuiTypography variant="14" fontWeight="400" color="text.lightgray">
            {BodyTitle}
          </MuiTypography>
        </MuiBox>
        <MuiBox
          sx={{
            display: "flex",
            width: "100%",
            height: "72px",
            backgroundColor: "background.gray200",
            borderRadius: "0 0 12px 12px",
            p: "16px 20px 16px 20px",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="whiteContained"
            sx={{
              width: "70px",
              border: "2px solid",
              borderColor: "background.blue600",
            }}
            onClick={() => {
              if (secondClose) {
                dispatch(closeSecondCenterModal());
              } else {
                dispatch(closeCenterModal());
              }
            }}
          >
            <MuiTypography variant="14" fontWeight="500" color="primary.main">
              {t("commonButton.cancel")}
            </MuiTypography>
          </Button>
          {backAction && (
            <Button
              variant="whiteContained"
              sx={{
                width: "fit-content",
                border: "2px solid",
                borderColor: "background.blue600",
              }}
            >
              <MuiTypography variant="14" fontWeight="500" color="primary.main">
                {backAction}
              </MuiTypography>
            </Button>
          )}
          <Button
            variant="blueContained"
            sx={{ width: "fit-content" }}
            onClick={onClick}
          >
            <MuiTypography variant="14" fontWeight="500">
              {action}
            </MuiTypography>
          </Button>
        </MuiBox>
      </MuiBox>
    </>
  );
};

export default CommonActionModal;
